import { pgTable, serial, text, integer, timestamp } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const teamAssignmentsTable = pgTable("team_assignments", {
  id: serial("id").primaryKey(),
  companyId: integer("company_id").notNull(),
  tenderId: integer("tender_id").notNull(),
  userId: integer("user_id"),
  userName: text("user_name").notNull(),
  userEmail: text("user_email"),
  role: text("role", { enum: ["lead", "member", "reviewer"] }).notNull().default("member"),
  notes: text("notes"),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const insertTeamAssignmentSchema = createInsertSchema(teamAssignmentsTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertTeamAssignment = z.infer<typeof insertTeamAssignmentSchema>;
export type TeamAssignment = typeof teamAssignmentsTable.$inferSelect;
